import React, { createContext, useContext } from "react"

export interface ProductPositionFormLoadingContextValue {
  isLoading?: boolean
  isLoadingPrice?: boolean
  isLoadingSpecialPriceGroups?: boolean
  isLoadingParentOptions?: boolean
  isLoadingPositionOptions?: boolean
  isLoadingProjectOptions?: boolean
  isLoadingPriceGroupOptions?: boolean
  isLoadingInstallationReferences?: boolean
}

const ProductPositionFormLoadingContext = createContext<
  ProductPositionFormLoadingContextValue | undefined
>(undefined)

export interface ProductPositionFormLoadingProviderProps {
  value: ProductPositionFormLoadingContextValue
  children: React.ReactNode
}

export const ProductPositionFormLoadingProvider = React.memo(
  ({ value, children }: ProductPositionFormLoadingProviderProps) => (
    <ProductPositionFormLoadingContext.Provider value={value}>
      {children}
    </ProductPositionFormLoadingContext.Provider>
  )
)

export function useProductPositionFormLoadingContext(): ProductPositionFormLoadingContextValue {
  const context = useContext(ProductPositionFormLoadingContext)
  if (!context) {
    throw new Error(
      "useProductPositionFormLoadingContext must be used within a ProductPositionFormLoadingProvider"
    )
  }
  return context
}
